import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import { WhatsAppIcon } from "./BrandIcons";
import WhatsAppContactModal from "./whatsapp/WhatsAppContactModal";

interface FloatingButtonsProps {
  onWhatsApp?: () => void;
  hideWhatsApp?: boolean;
}

export default function FloatingButtons({ onWhatsApp, hideWhatsApp }: FloatingButtonsProps) {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleWhatsAppClick = onWhatsApp ?? (() => setModalOpen(true));

  return (
    <>
      <WhatsAppContactModal open={modalOpen} onOpenChange={setModalOpen} />


      {/* Floating buttons */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 mb-[30px]" style={{ marginBottom: '30px' }}>
        {showBackToTop && (
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="bg-slate-800 hover:bg-slate-700 text-white rounded-full p-3 shadow-2xl transition-all transform hover:scale-110 flex items-center justify-center w-12 h-12 animate-fade-in"
            aria-label="Voltar ao topo"
          >
            <ChevronUp className="w-5 h-5" />
          </button>
        )}
        {!hideWhatsApp && (
          <button
            type="button"
            onClick={handleWhatsAppClick}
            className="bg-green-700 hover:bg-green-800 text-white rounded-full p-3 shadow-2xl transition-transform transform hover:scale-110 flex items-center justify-center w-12 h-12"
            aria-label="Falar no WhatsApp"
          >
            <WhatsAppIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    </>
  );
}
